<template>
  <div class="c-controls">
    <div class="c-controls__group">
      <label class="c-controls__label">Timer</label>
      <div class="c-videocontrols">
        <button v-on:click.prevent="startTimer">
          <svg class="icon icon_play"><use xlink:href="#icon_play"></use></svg>
        </button>
        <button v-on:click.prevent="pauseTimer">
          <svg class="icon icon_pause"><use xlink:href="#icon_pause"></use></svg>
        </button>
        <button v-on:click.prevent="stopTimer">
          <svg class="icon icon_stop"><use xlink:href="#icon_stop"></use></svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseControl from './BaseControl';

export default {
	name: 'TimerControl',
	mixins: [BaseControl],
	methods: {
    startTimer() {
      this.subcommand('timer.start');
    },
    stopTimer() {
      this.subcommand('timer.stop');
    },
    pauseTimer() {
      this.subcommand('timer.pause');
    },
	},
};
</script>

<style scoped></style>
